export const BATCH_REPORTS_INTERVAL_SECS = 5;
export const MAX_BATCH = 25;
export const REPORTING_EVENT_TYPE = 'EVENT_TYPE_TRACK';
